import {TRUNG_TAM, TINH} from "./area";
import {LUONG_MEM, LUONG_CUNG_THEO_BAC, LUONG_CUNG_CO_DINH} from "./mechanism";
import {JUNIOR, ROOKIE, EXECUTIVE, PRO, MASTER,} from './businessLevel'

export const SALE_LEADER = 1;
export const SALE_EXPERT = 2;
export const SALE_MEMBER = 3;
export const SALE_INTERN = 4;
export const GDVP = 5;
export const GDKV = 6;
export const GDVUNG = 26;
export const TEACHER = 7;
export const SUPPORT = 8;
export const STUDENT = 9;
export const CENTER = 10;
export const BRANCH = 11;
export const QLHV = 12;
export const CENTER_ASSIGN = 13;
export const STAFF = 14;
export const BOD = 15;
export const TEAMLEADER = 16;
export const HANH_CHINH_KHU_VUC = 18;
export const UNG_VIEN = 29;
export const TRUONG_NHOM = 34;
export const TRUONG_BO_PHAN = 32;

export const DOANH_SO_VI_TRI_MOI_SI = 24000000;
export const DOANH_SO_VI_TRI_MOI_S = 99000000;
export const DOANH_SO_VI_TRI_MOI_SE = 300000000;

export const DOANH_SO_CA_NHAN = 24000000;

export const DOANH_SO_DOI_SE = 66000000;
export const DOANH_SO_DOI_SL = 200000000;

export const accountTypeOption = [
    {name: QLHV, value: "Quản lý học viên"},
    {name: SALE_INTERN, value: "Sale Intern"},
    {name: SALE_MEMBER, value: "Sale"},
    {name: SALE_EXPERT, value: "Sale Expert"},
    {name: SALE_LEADER, value: "Sale Leader"},
    {name: GDVP, value: "Giám đốc văn phòng"},
];
export const ROLE_SALES_123  = 1;
export const ROLE_SALES_45   = 2;
export const ROLE_SALES_LEAD = 3;
export const ROLE_DIRECTOR   = 4;
export const ROLE_AREA       = 5;
export const ROLE_REGION     = 6;
export const ROLE_BOD        = 7;

export const ARRAY_TYPE_ACCOUNT = {
    40: ROLE_SALES_123,     // Sales
    30: ROLE_SALES_123,     // Sales
    318: ROLE_SALES_45,     // Sales Master
    314: ROLE_SALES_45,     // Sales Pro
    10: ROLE_SALES_LEAD,    // Sales Lead
    50: ROLE_DIRECTOR,        // Director
    60: ROLE_AREA,        // Director
    260: ROLE_REGION,        // Director
    150: ROLE_BOD,        // Director
};

export const ARRAY_TYPE_MANAGER = [ // Sales Lead
    ROLE_DIRECTOR,        // Director
    ROLE_AREA,        // Director
    ROLE_REGION,        // Director
    ROLE_BOD,        // Director
] ;

export const ARRAY_TYPE_SALE = [ // Sales Lead
    ROLE_SALES_123,
    ROLE_SALES_45,
    ROLE_SALES_LEAD,
    ROLE_DIRECTOR,
] ;

export const kiemNghiemOption = [
    {id: 'Trainer', name: 'Trainer'},
    {id: 'TVV', name: 'Tư vấn viên'},
];

export const ctvOption = [
    {id: 'ctv', name: 'Cộng tác viên'},
    {id: 'different', name: 'Khác cộng tác viên'},
]


export const kiemNghiemNew = [
    {id: 'TPOnline', name: 'TP Online'},
    {id: 'TVV', name: 'Tư vấn viên'},
    {id: 'Trainer', name: 'Trainer'},
];

export const businessLevels = [
    {
        id: 1,
        name: 'Junior'
    },
    {
        id: 2,
        name: 'Rookie'
    },
    {
        id: 3,
        name: 'Excutive'
    },
    {
        id: 4,
        name: 'Pro'
    },
    {
        id: 5,
        name: 'Master'
    }
]
export const levels = {
    1: 'Cấp 1',
    2: 'Cấp 2',
    3: 'Cấp 3',
    4: 'Cấp 4',
    5: 'Cấp 5'
}

export const TAI_KHOAN_CAP_TREN = [
    {id: 'sale-member', value: "Sale"},
    {id: 'sale-leader', value: "Sale Leader"},
    {id: 'gdvp', value: "Giám đốc văn phòng"},
];

export const ACCOUNT_TYPE_TEXT_TO_INT = {
    'sale-member': SALE_MEMBER,
    'sale-leader': SALE_LEADER,
    'gdvp': GDVP
}

export const TAI_KHOAN_CAP_TREN_ONLY_SALE = [
    {id: 'sale-leader', value: "Sale Leader"},
];

export const TPOL = ['TPOL', 'TPOnline'];
export const TPNS = ['TPNS'];
export const TVV = ['TVV'];
export const TRAINER = ['Trainer'];
export const POSITION = ['TVV', 'TPOnline', 'Trainer'];

export const GDVPorGDKV = [GDVP, GDKV];

export const WATCH_AS_TP = [
    {
        id: 0,
        value: 'TPhòng/Giám đốc',
        label: 'TP/GĐ'
    },
    {
        id: 1,
        value: 'Đội kinh doanh',
        label: 'Đội'
    },
    {
        id: 2,
        value: 'Cá nhân',
        label: 'Cá nhân'
    }
];

export const WATCH_AS_SALE = [
    {
        id: 1,
        value: 'Đội kinh doanh',
        label: 'Đội'
    },
    {
        id: 2,
        value: 'Cá nhân',
        label: 'Cá nhân'
    }
];

//PERSONAL
let PERSONAL_TRUNG_TAM = {}
PERSONAL_TRUNG_TAM[JUNIOR] = 25000000;
PERSONAL_TRUNG_TAM[ROOKIE] = 25000000;
PERSONAL_TRUNG_TAM[EXECUTIVE] = 30000000;
PERSONAL_TRUNG_TAM[PRO] = 35000000;
PERSONAL_TRUNG_TAM[MASTER] = 40000000;

let PERSONAL_TINH_LUONG_MEM = {}
PERSONAL_TINH_LUONG_MEM[JUNIOR] = 25000000;
PERSONAL_TINH_LUONG_MEM[ROOKIE] = 25000000;
PERSONAL_TINH_LUONG_MEM[EXECUTIVE] = 30000000;
PERSONAL_TINH_LUONG_MEM[PRO] = 35000000;
PERSONAL_TINH_LUONG_MEM[MASTER] = 40000000;

let PERSONAL_TINH_LUONG_CUNG_THEO_BAC = {}
PERSONAL_TINH_LUONG_CUNG_THEO_BAC[JUNIOR] = 50000000;
PERSONAL_TINH_LUONG_CUNG_THEO_BAC[ROOKIE] = 60000000;
PERSONAL_TINH_LUONG_CUNG_THEO_BAC[EXECUTIVE] = 70000000;
PERSONAL_TINH_LUONG_CUNG_THEO_BAC[PRO] = 80000000;
PERSONAL_TINH_LUONG_CUNG_THEO_BAC[MASTER] = 90000000;

let PERSONAL_TINH_LUONG_CUNG_CO_DINH = {}
PERSONAL_TINH_LUONG_CUNG_CO_DINH[JUNIOR] = 55000000;
PERSONAL_TINH_LUONG_CUNG_CO_DINH[ROOKIE] = 55000000;
PERSONAL_TINH_LUONG_CUNG_CO_DINH[EXECUTIVE] = 55000000;
PERSONAL_TINH_LUONG_CUNG_CO_DINH[PRO] = 55000000;
PERSONAL_TINH_LUONG_CUNG_CO_DINH[MASTER] = 55000000;

export const TARGET_PERSONAL = {}
TARGET_PERSONAL[TRUNG_TAM] = PERSONAL_TRUNG_TAM;
TARGET_PERSONAL[TINH] = {};
TARGET_PERSONAL[TINH][LUONG_MEM] = PERSONAL_TINH_LUONG_MEM;
TARGET_PERSONAL[TINH][LUONG_CUNG_THEO_BAC] = PERSONAL_TINH_LUONG_CUNG_THEO_BAC;
TARGET_PERSONAL[TINH][LUONG_CUNG_CO_DINH] = PERSONAL_TINH_LUONG_CUNG_CO_DINH;


// TEAM
let TARGET_TEAM_TRUNG_TAM = {};
TARGET_TEAM_TRUNG_TAM[JUNIOR] = 100000000;
TARGET_TEAM_TRUNG_TAM[ROOKIE] = 150000000;
TARGET_TEAM_TRUNG_TAM[EXECUTIVE] = 200000000;
TARGET_TEAM_TRUNG_TAM[PRO] = 250000000;
TARGET_TEAM_TRUNG_TAM[MASTER] = 300000000;

let TARGET_TEAM_TINH = {};
TARGET_TEAM_TINH[JUNIOR] = 250000000;
TARGET_TEAM_TINH[ROOKIE] = 300000000;
TARGET_TEAM_TINH[EXECUTIVE] = 350000000;
TARGET_TEAM_TINH[PRO] = 400000000;
TARGET_TEAM_TINH[MASTER] = 450000000;

export const TARGET_TEAM = {}
TARGET_TEAM[TRUNG_TAM] = TARGET_TEAM_TRUNG_TAM;
TARGET_TEAM[TINH] = TARGET_TEAM_TINH;
